import PropTypes from 'prop-types';
import React from 'react';

import UserInfoForm from '../UserInfoForm';

export default class UserRegistrationCheck extends React.Component {
  static contextTypes = {
    getCurrentUserInfo: PropTypes.func
  };

  render() {
    const user = this.context.getCurrentUserInfo();
    const hasAllRequiredInfo = user.hasAllRequiredInfo;

    // return <UserInfoForm user={user} {...this.props} />;

    if (!hasAllRequiredInfo && !window.__bypassUserInfoCheck) {
      return <UserInfoForm user={user} {...this.props} />;
    }

    return this.props.children;
  }
}
